import { useDetail } from 'storfox-api-hooks'

import * as API from '~/constants/api'

export const useStorageReportDetail = () => {
  return useDetail(API.STORAGE_REPORT_DETAIL)
}
